import { defineComponent as _defineComponent } from 'vue'
import { ISeatInfo } from "@/domain/entities/book";
import { PropType, ref } from "vue";
import SeatsLayout from "@/components/book/SeatsLayout.vue";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import { Effect } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SeatsLayoutSwiper',
  props: {
  seatsInfosList: {
    type: Array as PropType<(ISeatInfo | undefined)[][]>,
    required: true,
  },
  seatsRowsNumList: {
    type: Object as PropType<number[]>,
    required: true,
  },
  seatsColumnsNumList: {
    type: Object as PropType<number[]>,
    required: true,
  },
  mySeatNo: {
    type: String,
  },
  selectable: {
    type: Boolean,
    default: false,
  },
  backgroundColor: {
    type: String,
    default: "#2c5947",
  },
  seatFontColor: {
    type: String,
    default: "#fff",
  },
  selectedSeatBackgroundColor: {
    type: String,
    default: "#fff",
  },
  selectedSeatFontColor: {
    type: String,
    default: "#154733",
  },
  duplicateSeatNo: {
    type: String,
  },
},
  emits: ["onClickSeat"],
  setup(__props, { expose: __expose, emit: __emit }) {

SwiperCore.use([EffectCoverflow, Pagination]);

const props = __props;

const emit = __emit;

const seatsLayoutRef = ref<InstanceType<typeof SeatsLayout>>();

const swiperOptions = {
  modules: [EffectCoverflow],
  effect: "coverflow" as Effect,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 0,
    modifier: 1,
    slideShadows: false,
  },
  centeredSlides: true,
  loop: false,
  slidesPerView: 1,
  pagination: {
    el: ".seats_pagination_bullet",
  },
  paginationClickable: false,
};

const onClickSeat = (seatInfo: ISeatInfo) => {
  if (!props.selectable) {
    return;
  }
  emit("onClickSeat", seatInfo);
};

__expose({ seatsLayoutRef });

const __returned__ = { props, emit, seatsLayoutRef, swiperOptions, onClickSeat, SeatsLayout, get Swiper() { return Swiper }, get SwiperSlide() { return SwiperSlide } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})